// SPDX-License-Identifier: LicenseRef-MMS-WIRE
// Copyright (c) 2016-2026 Metal Management Solutions (Pty) Ltd

import { Component } from '@angular/core';
import {HeaderDataService} from "../../services/header_data.service";
import {AppScope} from "../../services/app_scope.service";
import {MatSidenav, MatSidenavContainer, MatSidenavContent} from "@angular/material/sidenav";
import {BreadcrumbsComponent} from "../../menu-bars/breadcrumbs/breadcrumbs.component";
import {RouterOutlet} from "@angular/router";
import {CommonModule} from "@angular/common";
import {NotificationsComponent} from "../../notifications/notifications/notifications.component";
import {NotificationsDirective} from "../../directives/notifications.directive";
import {HeaderComponent} from "../../menu-bars/header.component";
import {SideNavigation} from "../../menu-bars/side-nav.component";
import {MatDrawerMode} from "@angular/material/sidenav";

@Component({
    selector: 'main-sidenav',
    templateUrl: './main-sidenav.component.html',
    imports: [
        MatSidenavContainer,
        MatSidenav,
        MatSidenavContent,
        BreadcrumbsComponent,
        RouterOutlet,
        CommonModule,
        NotificationsComponent,
        NotificationsDirective,
        HeaderComponent,
        SideNavigation
    ],
    styleUrls: ['./main-sidenav.component.scss']
})
export class MainSidenavComponent {
  finishedLoading: boolean;
  sidenav_mode: MatDrawerMode = 'over';

  constructor(public headerData: HeaderDataService,
              public appScope: AppScope) {
  }

  ngOnInit(): void {
  }
}
